import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import { ThemeProvider } from "@/components/ThemeController";
import Curtain from "@/components/Curtain";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import BrandBanner from "@/components/BrandBanner";
import EditorialMarquee from "@/components/EditorialMarquee";
import Fleet from "@/components/Fleet";
import Manifesto from "@/components/Manifesto";
import Gallery from "@/components/Gallery";
import Testimonial from "@/components/Testimonial";
import { InstagramPortfolio } from "@/components/InstagramPortfolio";
import { FancyTexters, WhatsAppFab } from "@/components/WhatsApp";
import Coverage from "@/components/Coverage";
import BigCTA from "@/components/BigCTA";
import Footer from "@/components/Footer";
import AdminReviews from "@/components/AdminReviews";
import WorkDetail from "@/pages/WorkDetail";
import CrmLogin from "@/pages/CrmLogin";
import CrmShell from "@/pages/CrmShell";
import { CrmDashboard } from "@/pages/CrmDashboard";
import CrmClients from "@/pages/CrmClients";
import { CrmInvoices, CrmInvoiceNew } from "@/pages/CrmInvoices";
import CrmInvoiceDetail from "@/pages/CrmInvoiceDetail";
import CrmInstagram from "@/pages/CrmInstagram";
import PublicPay from "@/pages/PublicPay";
import OurWork from "@/pages/OurWork";

function Home() {
    return (
        <ThemeProvider>
            <div className="App grain min-h-screen bg-black text-white">
                <Curtain />
                <SmoothScroll>
                    <Nav />
                    <main data-testid="main">
                        <Hero />
                        <BrandBanner />
                        <EditorialMarquee speed={22} testId="marquee-top" />
                        <Fleet />
                        <EditorialMarquee
                            speed={28}
                            filled
                            testId="marquee-mid"
                        />
                        <Manifesto />
                        <Gallery />
                        <Testimonial />
                        <InstagramPortfolio />
                        <FancyTexters />
                        <Coverage />
                        <BigCTA />
                        <Footer />
                    </main>
                    <WhatsAppFab />
                </SmoothScroll>
            </div>
        </ThemeProvider>
    );
}

function App() {
    const params =
        typeof window !== "undefined"
            ? new URLSearchParams(window.location.search)
            : new URLSearchParams();
    const adminKey = params.get("admin");

    if (adminKey) {
        return <AdminReviews adminKey={adminKey} />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/work/:slug" element={<WorkDetail />} />
                <Route path="/our-work" element={<OurWork />} />
                <Route path="/pay/:token" element={<PublicPay />} />
                <Route path="/crm/login" element={<CrmLogin />} />
                <Route path="/crm" element={<CrmShell />}>
                    <Route index element={<CrmDashboard />} />
                    <Route path="clients" element={<CrmClients />} />
                    <Route path="invoices" element={<CrmInvoices />} />
                    <Route path="invoices/new" element={<CrmInvoiceNew />} />
                    <Route path="invoices/:id" element={<CrmInvoiceDetail />} />
                    <Route path="instagram" element={<CrmInstagram />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
